import {
  TypedUseSelectorHook,
  useStore,
  useDispatch,
  useSelector,
} from 'react-redux';
import type {AppStore, RootState, AppDispatch} from './store';
import {Role} from '../net/types/graphql';

/**
 * Typed version of useStore.
 */
export const useAppStore = (): AppStore => useStore<RootState>();

/**
 * Typed version of useDispatch.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;

/**
 * Typed version of useSelector.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Check if current user has ADMIN permission.
 */
export const useIsAdmin = () =>
  useAppSelector(({auth}) => (auth.roles || []).includes(Role.Admin));

/**
 * Check if current user has STAFF permission.
 */
export const useIsStaff = () =>
  useAppSelector(({auth}) => (auth.roles || []).includes(Role.Staff));
